import React from 'react';
import cx from 'classnames';

import classes from './Menu.module.scss';

interface IProps {
  className?: string;
  children: React.ReactNode;
}

const List: React.FC<IProps> = ({ className, children }) => (
  <div className={cx(classes.list, className)}>{children}</div>
);

export default List;